const ServiceType = {
    "TransactionalCredit": {
        core: "venify",
        path: "/transactionalCredit"
    },
    "FinCheck": {
        core: "venify",
        path: "/finCheck"
    },
    "CompanyApproval": {
        core: "venify",
        path: "/companyApproval"
    },
    "PoliceClearance": {
        core: "venify",
        path: "/authentications",
    },
    "OriginalityDevice": {
        core: "venify",
        path: "/originalityDevice",

    },
    "ForeignerAuth": {
        core: "venify",
        path: "/authentications/ForeignerAuth",

    },
    "IAuth": {
        core: "venify",
        path: "/authentications",
        path1: "/venify/iAuth",
    },
    "DivarInternalAuth": {
        core: "venify",
        path: "/authentications/userAuthentication"
    },
    "DivarInternalCar": {
        core: "venify",
        path: "/divarInternalCar"
    },
    "DivarInternalEstate": {
        core: "venify",
        path: "/divarInternalEstate"
    },
    "BusinessLicenseInquiry": {
        core: "venify",
        path: "/authentications",
        path1: "/venify/iAuth",
    },
    "ExpertInquiry": {
        core: "venify",
        path: "/authentications",
        path1: "/venify/iAuth",
    },
    "LawyerInquiry": {
        core: "venify",
        path: "/authentications",
        path1: "/venify/iAuth",
    },
    "Estate": {
        core: "venify",
        path: "/venify/estateOriginality",
    },
    "CService": {
        core: 'venesh',
        path: "/venesh/CService",
    },
    "NIDCardReader": {
        core: "venify",
        path: "/venify/NIDCardReader",
    },
    "CompareFaces": {
        core: "venify",
        path: "/venify/CompareFaces",
    },
    "ChequeReader": {
        core: "venify",
        path: "/venify/ChequeReader",
    },
    "VideoValidation": {
        core: "venify",
        path: "/venify/VideoValidation",
    },
    "NIDVerification": {
        core: 'venesh',
        path: "/venesh/VideoValidation",
    },
    "FacilityInquiry": {
        core: 'venesh',
        path: "/venesh/FacilityInquiry"
    },
    "BackChequesInquiry": {
        core: 'venesh',
        path: "/venesh/BackChequesInquiry"
    },
    "PostCodeInquiry": {
        core: 'venesh',
        path: "/venesh/PostCodeInquiry"
    },
    "BillInquiry": {
        core: 'venesh',
        path: "/venesh/BillInquiry",

    },
    "ChequeInquiry": {
        core: 'venesh',
        path: "/venesh/ChequeInquiry",

    },
    "CompanyInquiry": {
        core: 'venesh',
        path: "/venesh/ChequeInquiry",

    },
    "SendSMSNew": {
        core: 'venesh',
        path: "/venesh/SendSMSNew",
    },
    "BulkBillInquiry": {
        core: 'venesh',
        path: "/venesh/BulkBillInquiry",
    },
    "Bills": {
        core: 'venesh',
        path: "/tosan",

    },

    "CarExpensesPayment": {
        core: 'venesh',
        path: "/venesh/CService",
    },
}

export default ServiceType;
